import { shallowRef } from 'vue';
import { defineStore } from 'pinia';

import type { PqvPayloadBasic, PqvOptionsBasic } from '@nuxt-common/product-quickview/app/types';

export type PqvPayloadBasicType = PqvPayloadBasic | null;
export type PqvOptionsBasicType = PqvOptionsBasic | Record<string, never>;
export type PqvTaggingBasicType = PqvOptionsBasic['tagging'] | Record<string, never>;

export const useProductQuickviewStore = defineStore('pdpProductQuickviewStore', () => {
  const pdpPqvPayload = shallowRef<PqvPayloadBasicType>(null);
  const pdpPqvOptions = shallowRef<PqvOptionsBasicType>({});
  const pdpPqvTagging = shallowRef<PqvTaggingBasicType>({});

  function setPdpPqvPayload(payload?: PqvPayloadBasic) {
    if (payload) {
      pdpPqvPayload.value = payload;
    }
  }

  function setPdpPqvOptions(options?: PqvOptionsBasic) {
    if (options) {
      pdpPqvOptions.value = options;
    }
  }

  function setPdpPqvTagging(tagging?: PqvTaggingBasicType) {
    if (tagging) {
      pdpPqvTagging.value = tagging;
    }
  }

  function clearPdpPqvTagging() {
    pdpPqvTagging.value = {};
  }

  return {
    pdpPqvPayload,
    pdpPqvOptions,
    pdpPqvTagging,
    setPdpPqvPayload,
    setPdpPqvOptions,
    setPdpPqvTagging,
    clearPdpPqvTagging,
  };
});
